export default () => ({
  referralLink: '',
  collectionChoice: null,
  accountCreated: false,
  userId: null
})
